module.exports = __webpack_public_path__ + "img/5.e0797d33.png";